import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ModalController } from "ionic-angular";

import { ApiService } from "../../services/api.service";
import { ActivityLogService } from "../../services/activity-log.service";
import { DataService } from "../../services/data.service";
import { WorkorderService } from "../../services/workorder.service";
import { ReportService } from "../../services/report.service";
import { NotificationService } from "../../services/notification.service";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { AlertController } from "ionic-angular";
import { DatePipe } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

import { LoginPage } from "../login/login";
import { NewsModalPage } from "../news-modal/news-modal";
import { WorkordersPage } from "../workorders/workorders";

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  busy = false;
  completed_workorders_count = 0;

  workorders: any[] = [];
  workordersLoading = 0;

  news: any[] = [];
  newsLoading = 0;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private datePipe: DatePipe,
    public apiService: ApiService,
    public workorderService: WorkorderService,
    public activityLogService: ActivityLogService,
    public reportService: ReportService,
    public iab: InAppBrowser,
    public translate: TranslateService,
    public notificationService: NotificationService,
    public dataService: DataService
  ){}

  public openLogin(){
    var modal = this.modalCtrl.create(LoginPage, {}, {
      enableBackdropDismiss: false,
      cssClass: 'modal-fullscreen'
    });
    modal.onDidDismiss(() => {
      console.log('loginPage modal closed');
    });
    modal.present();
  }

  public goToReport(){
    let tabs = this.navCtrl.parent;
    tabs.select(1);
  }

  public goToWorkorder(workorder) {
    if(this.reportService.isActive()){
      this.alertCtrl.create({
        title: 'Waarschuwing',
        message: 'Je kunt deze werkorder niet openen, omdat je nog bezig bent met een andere werkorder. Klik onderaan op \'Werkorders\' om naar de werkorder te gaan waarmee je bezig bent.',
        cssClass: 'alert-error',
        buttons: ['OK']
      }).present();
      return;
    }
    let tabs = this.navCtrl.parent;
    tabs.select(1).then(() => {
      setTimeout(() => {
        let page = tabs.getSelected().getActive().instance;
        if(page instanceof WorkordersPage){
          /** @var page WorkordersPage **/
          page.selectWorkorder(workorder);
        }
      }, 500);
    });
  }

  public goToNewWorkorder() {
    let tabs = this.navCtrl.parent;
    tabs.select(1).then(() => {
      setTimeout(() => {
        let page = tabs.getSelected().getActive().instance;
        if(page instanceof WorkordersPage){
          /** @var page WorkordersPage **/
          page.chooseNewWorkorderType();
        }
      }, 500);
    });
  }

  public goToSearchUnit(){
    let tabs = this.navCtrl.parent;
    tabs.select(2);
  }

  public goToCompanyFiles(){
    let tabs = this.navCtrl.parent;
    tabs.select(3);
  }

  public goToNews(){
    var modal = this.modalCtrl.create(NewsModalPage, {}, {
      enableBackdropDismiss: false,
      cssClass: 'modal-fullscreen'
    });
    modal.present();
  }

  public goToFeedback() {
    this.dataService.openFeedbackForm();
  }

  ionViewDidEnter(){
    console.log('ionViewDidEnter HomePage');
    this.updateWorkorders();
    this.loadNews();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HomePage');
    this.apiService.isLoggedIn().then((result) => {
      console.log('isLoggedIn: ' + result);
      if(!result) {
        this.openLogin();
      } else {
        // Log app start
        this.activityLogService.log('app_start');
      }
    }).catch(() => {
      this.openLogin();
    });
  }

  updateWorkorders(){
    // Get workorders from API
    this.apiService.getWorkorders().then((data) => {
      this.workorderService.setWorkorders(data, true).then(() => {
        this.getWorkorders();
      }).catch((err) => {
        this.getWorkorders();
      });
    }).catch((err) => {
      this.getWorkorders();
    })
  }

  private sortByTimePlanned(a, b){
    let a_time_planned = a.time_planned ? parseInt(a.time_planned) : 0;
    let b_time_planned = b.time_planned ? parseInt(b.time_planned) : 0;
    if (a_time_planned > b_time_planned) return 1;
    if (b_time_planned > a_time_planned) return -1;
    return 0;
  }

  getWorkorders() {
    this.workordersLoading = 1;
    this.workorderService.getWorkorders().then((workorders: any) => {
      this.workordersLoading = 0;
      this.workorders = [];
      for(let workorder of workorders) {
        if(workorder._status !== 'done'){
          this.workorders.push(workorder);
        }
      }
      this.workorders = this.workorders.sort(this.sortByTimePlanned);
    }).catch((err) => {
      this.workordersLoading = -1;
      console.error(err);
    });
  }

  loadNews() {
    this.apiService.getHomeNews().then((data: any) => {
      this.newsLoading = 0;
      this.news = data;
      // Check for important news after loading
      this.openImportantNews();
    }).catch((error) => {
      this.newsLoading = -1;
      console.error(error);
    });
  }

  async openImportantNews() {
    if (!this.news || this.news.length === 0) {
      return;
    }

    for (let newsItem of this.news) {
      // Check if news item is important and has required properties
      if (newsItem.important && newsItem.important > 0 && newsItem.news_id) {
        try {
          // Check if this news item has already been opened
          const isOpened = await this.apiService.getOpenedImportantNews(newsItem.news_id);

          if (!isOpened) {
            // Show alert with news content
            const alert = this.alertCtrl.create({
              title: this.translate.instant('Belangrijk nieuws'),
              subTitle: newsItem.title,
              message: newsItem.description,
              buttons: [
                {
                  text: this.translate.instant('Sluiten'),
                  role: 'cancel'
                }
              ]
            });

            // Add link button if news item has a link
            if (newsItem.link) {
              alert.addButton({
                text: this.translate.instant('Lees meer'),
                handler: () => {
                  this.iab.create(newsItem.link, '_system');
                }
              });
            }

            // Mark as opened when alert is shown
            try {
              await this.apiService.setOpenedImportantNews(newsItem.news_id);
            } catch (error) {
              console.error('Error saving opened news:', error);
            }

            // Present the alert
            alert.present();
          }
        } catch (error) {
          console.error('Error checking opened news:', error);
        }
      }
    }
  }

  openNewsLink(record){
    if(record.link){
      this.iab.create(record.link, '_system');
    }
  }

  getWorkorderTitle1(workorder){
    if(workorder.customers&& workorder.customers.client){
      if(workorder.customers.client.list_title){
        return (workorder.customers.client.list_title).trim();
      }
      if(workorder.customers.client.firstname || workorder.customers.client.lastname || workorder.customers.client.company){
        return (workorder.customers.client.firstname + ' ' + workorder.customers.client.lastname + ' ' + workorder.customers.client.company).trim();
      }
    }
    return this.translate.instant('Onbekende klant');
  }

  getWorkorderTitle2(workorder){
    if(workorder.location){
      let out= (((workorder.location.street ? workorder.location.street : '') + ' ' + (workorder.location.number ? workorder.location.number : '') + ' ' + (workorder.location.letter ? workorder.location.letter : '')).trim()
        + ' ' + (workorder.location.city ? workorder.location.city : '').trim()).trim();
      if(out){
        return out;
      }
    }
    return this.translate.instant('Onbekende locatie');
  }

  getWorkorderUnitTitle(workorder){
    if(workorder._selected_units && workorder._selected_units.length > 0 && workorder._selected_units[0].list_subtitle){
      let unit = workorder._selected_units[0];
      return unit.list_title.trim();
    }
    return 'Geen installatie geselecteerd';
  }

  getDisplayTimePlanned(workorder){
    if(!workorder.time_planned){
      return '';
    }
    let date = new Date(workorder.time_planned * 1000);
    let out = this.datePipe.transform(date,  'dd-MM-yyyy');
    if(workorder.daypart && workorder.daypart.time_start && workorder.daypart.time_end){
      let time_start = workorder.daypart.time_start.substr(0,5);
      let time_end = workorder.daypart.time_end.substr(0,5);
      out += ' (' + time_start + '-' + time_end + ')';
    }
    return out;
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts